var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"BotonVerMapa dIB mT20",attrs:{"to":_vm.route}},[_vm._v("Ver Mapa")])}
var staticRenderFns = []

export { render, staticRenderFns }